import Vue from "vue";
import VueRouter from "vue-router";
import store from "../stores/store";
import cookieConsent from "@/mixins/cookieConsent/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
  },
  {
    path: "/sign-in",
    name: "sign_in",
    component: () =>
      import(/* webpackChunkName: "UserSignIn" */ "../views/UserSignIn.vue"),
  },
  {
    path: "/sign-up",
    name: "sign_up",
    component: () =>
      import(/* webpackChunkName: "UserSignUp" */ "../views/UserSignUp.vue"),
  },
  {
    path: "/user/",
    name: "user_profile",
    component: () =>
      import(/* webpackChunkName: "UserProfile" */ "../views/UserProfile.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/user/edit",
    name: "user_edit",
    component: () =>
      import(/* webpackChunkName: "UserEdit" */ "../views/UserEdit.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/user/blocked-users",
    name: "blocked_users",
    component: () =>
      import(/* webpackChunkName: "UserEdit" */ "../views/BlockedUsers.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/forgot-password/",
    name: "forgot_password",
    component: () =>
      import(
        /* webpackChunkName: "ForgotPassword" */ "../views/UserForgotPassword.vue"
      ),
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  // {
  //   path: "/chats",
  //   name: "chats",
  //   component: () =>
  //     import(/* webpackChunkName: "chats" */ "../views/Chats.vue"),
  //   beforeEnter: requireAuth,
  // },
  {
    path: "/posts",
    name: "posts",
    component: () =>
      import(/* webpackChunkName: "Posts" */ "../views/Posts.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/legal/",
    name: "legal",
    component: () =>
      import(
        /* webpackChunkName: "LegalArticle" */ "../views/LegalArchive.vue"
      ),
  },
  {
    path: "/legal/:id",
    name: "legal_information",
    component: () =>
      import(/* webpackChunkName: "Legal" */ "../views/LegalArticle.vue"),
  },
  {
    path: "/surveys",
    name: "surveys",
    component: () =>
      import(/* webpackChunkName: "Surveys" */ "../views/Surveys.vue"),
    beforeEnter: requireAuth,
  },
  {
    path: "/cms_pages/:id",
    name: "cms_page",
    component: () =>
      import(/* webpackChunkName: "CmsPage" */ "../views/CmsPage.vue"),
  },
  {
    path: "/organisations/",
    name: "organisations_archive",
    component: () =>
      import(
        /* webpackChunkName: "CmsPage" */ "../views/OrganisationsArchive.vue"
      ),
  },
  {
    path: "/organisations/:id",
    name: "organisations_article",
    component: () =>
      import(
        /* webpackChunkName: "CmsPage" */ "../views/OrganisationsArticle.vue"
      ),
  },
  {
    path: "/events",
    name: "events_archive",
    component: () =>
      import(/* webpackChunkName: "Events" */ "../views/EventsArchive.vue"),
  },
  {
    path: "/event/:id",
    name: "event_article",
    component: () =>
      import(/* webpackChunkName: "CmsPage" */ "../views/EventsArticle.vue"),
  },
  {
    path: "/contact/",
    name: "contact",
    component: () =>
      import(/* webpackChunkName: "Contact" */ "../views/Contact.vue"),
  },
  {
    path: "/welcome/",
    name: "welcome",
    component: () =>
      import(/* webpackChunkName: "Welcome" */ "../views/Welcome.vue"),
  },
  {
    path: "/terms/",
    name: "terms",
    component: () =>
      import(/* webpackChunkName: "Terms" */ "../views/Terms.vue"),
  },
  {
    path: "/app-terms/",
    name: "app_terms",
    component: () =>
      import(/* webpackChunkName: "Terms" */ "../views/TermsInApp.vue"),
  },
  {
    path: "/app-privacy/",
    name: "app_privacy",
    component: () =>
      import(/* webpackChunkName: "Search" */ "../views/PrivacyInApp.vue"),
  },
  {
    path: "/app-accessibility/",
    name: "app_accessibility",
    component: () =>
      import(
        /* webpackChunkName: "Search" */ "../views/AccessibilityInApp.vue"
      ),
  },
  {
    path: "/app-search/",
    name: "search",
    component: () =>
      import(/* webpackChunkName: "Search" */ "../views/AppSearch.vue"),
  },
  {
    path: "/favourites",
    name: "favourites",
    component: () =>
      import(/* webpackChunkName: "Search" */ "../views/Favourites.vue"),
  },
  {
    path: "/vips",
    name: "vips",
    component: () =>
      import(/* webpackChunkName: "Search" */ "../views/Vips.vue"),
  },
  {
    path: "/infoandadvice",
    name: "infoandadvice",
    component: () =>
      import(/* webpackChunkName: "Search" */ "../views/InfoAndAdvice.vue"),
  },
  {
    path: "/opportunities",
    name: "opportunities_archive",
    component: () =>
      import(
        /* webpackChunkName: "Search" */ "../views/OpportunitiesArchive.vue"
      ),
  },
  {
    path: "/opportunity/:id",
    name: "opportunities_article",
    component: () =>
      import(
        /* webpackChunkName: "Search" */ "../views/OpportunitiesArticle.vue"
      ),
  },
  {
    path: "/budget-planner",
    name: "budget_planner",
    component: () =>
      import(
        /* webpackChunkName: "BudgetPlanner" */ "../views/BudgetPlanner.vue"
      ),
  },
  {
    path: "/account-deleted",
    name: "account_deleted",
    component: () =>
      import(
        /* webpackChunkName: "AccountDeleted" */ "../views/AccountDeleted.vue"
      ),
  },
  {
    path: "/education-training-and-employment",
    name: "education_training_and_employment",
    component: () =>
      import(
        /* webpackChunkName: "WorkAndOpportunities" */ "../views/WorkOpportunities.vue"
      ),
  },
  {
    path: "/events-and-activities",
    name: "events_and_activities",
    component: () =>
      import(
        /* webpackChunkName: "EventsAndActivities" */ "../views/EventsActivities.vue"
      ),
  },
  {
    path: "/offers",
    name: "offers_archive",
    component: () =>
      import(
        /* webpackChunkName: "OffersArchive" */ "../views/OffersArchive.vue"
      ),
  },
  {
    path: "/offer/:id",
    name: "offers_article",
    component: () =>
      import(
        /* webpackChunkName: "OffersArticle" */ "../views/OffersArticle.vue"
      ),
  },
  {
    path: "/community",
    name: "community",
    component: () =>
      import(/* webpackChunkName: "Community" */ "../views/Community.vue"),
  },
  {
    path: "/mental-health-toolkit",
    name: "toolkit",
    component: () =>
      import(/* webpackChunkName: "Toolkit" */ "../views/Toolkit.vue"),
  },
  {
    path: "/mental-health-toolkit/archive/:category",
    name: "toolkit_archive",
    component: () =>
      import(
        /* webpackChunkName: "ToolkitArchive" */ "../views/ToolkitArchive.vue"
      ),
  },
  {
    path: "/mental-health-toolkit/search/:search",
    name: "toolkit_search",
    component: () =>
      import(
        /* webpackChunkName: "ToolkitSearch" */ "../views/ToolkitSearch.vue"
      ),
  },
  {
    path: "/mental-health-toolkit/:id",
    name: "toolkit_article",
    component: () =>
      import(
        /* webpackChunkName: "ToolkitArticle" */ "../views/ToolkitArticle.vue"
      ),
  },
  {
    path: "/education",
    name: "education",
    component: () =>
      import(/* webpackChunkName: "Education" */ "../views/Education.vue"),
  },
  {
    path: "/education/:id",
    name: "education_article",
    component: () =>
      import(
        /* webpackChunkName: "Education" */ "../views/EducationArticle.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      setTimeout(function () {
        window.scroll(0, savedPosition.y);
      }, 50);
      return;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

router.beforeEach((to, from, next) => {
  const isWelcomePage = to.name === "welcome";
  const hasRequiredData =
    localStorage.getItem("current_lang") &&
    localStorage.getItem("terms_accepted");
  const isApp = window.cordova;
  // localStorage.getItem("current_lang") && localStorage.getItem("terms_accepted") && localStorage.getItem("user_type") && localStorage.getItem("user_location")

  if (!isWelcomePage && !hasRequiredData) {
    next({ name: "welcome" });
  } else if (isWelcomePage && hasRequiredData) {
    next({ name: "home" });
  } else {
    next();
  }

  // initialize cookie consent if not on the welcome page and all required data is present
  if (!isApp && !isWelcomePage && hasRequiredData) {
    cookieConsent.methods.initCookieConsent();
  }
});

function requireAuth(to, from, next) {
  if (store.getters["user/isTokenSet"]) {
    next();
  } else {
    next({
      path: "/sign-in",
      query: { redirect: to.name },
    });
  }
}

export default router;
